import { relations } from "drizzle-orm/relations";
import { tenants, roles, users, userRoles, tenantUsers, patientProfiles, ehrIntegrations, patientPaymentMethods, healthRecordUploads, consultations, roleResourcePermissions } from "./schema";

export const rolesRelations = relations(roles, ({one, many}) => ({
	tenant: one(tenants, {
		fields: [roles.tenantId],
		references: [tenants.id]
	}),
	userRoles: many(userRoles),
	roleResourcePermissions_roleId: many(roleResourcePermissions, {
		relationName: "roleResourcePermissions_roleId_roles_id"
	}),
	roleResourcePermissions_targetRoleId: many(roleResourcePermissions, {
		relationName: "roleResourcePermissions_targetRoleId_roles_id"
	}),
}));

export const tenantsRelations = relations(tenants, ({one, many}) => ({
	roles: many(roles),
	user: one(users, {
		fields: [tenants.userId],
		references: [users.id]
	}),
	tenantUsers: many(tenantUsers),
}));

export const userRolesRelations = relations(userRoles, ({one}) => ({
	user: one(users, {
		fields: [userRoles.userId],
		references: [users.id]
	}),
	role: one(roles, {
		fields: [userRoles.roleId],
		references: [roles.id]
	}),
}));

export const usersRelations = relations(users, ({many}) => ({
	userRoles: many(userRoles),
	tenants: many(tenants),
	tenantUsers: many(tenantUsers),
	patientPaymentMethods: many(patientPaymentMethods),
	patientProfiles: many(patientProfiles),
	consultations: many(consultations),
}));

export const tenantUsersRelations = relations(tenantUsers, ({one}) => ({
	tenant: one(tenants, {
		fields: [tenantUsers.tenantId],
		references: [tenants.id]
	}),
	user: one(users, {
		fields: [tenantUsers.userId],
		references: [users.id]
	}),
}));

export const ehrIntegrationsRelations = relations(ehrIntegrations, ({one, many}) => ({
	patientProfile: one(patientProfiles, {
		fields: [ehrIntegrations.patientId],
		references: [patientProfiles.id]
	}),
	healthRecordUploads: many(healthRecordUploads),
}));

export const patientProfilesRelations = relations(patientProfiles, ({one, many}) => ({
	ehrIntegrations: many(ehrIntegrations),
	user: one(users, {
		fields: [patientProfiles.userId],
		references: [users.id]
	}),
	healthRecordUploads: many(healthRecordUploads),
}));

export const patientPaymentMethodsRelations = relations(patientPaymentMethods, ({one}) => ({
	user: one(users, {
		fields: [patientPaymentMethods.userId],
		references: [users.id]
	}),
}));

export const healthRecordUploadsRelations = relations(healthRecordUploads, ({one}) => ({
	patientProfile: one(patientProfiles, {
		fields: [healthRecordUploads.patientId],
		references: [patientProfiles.id]
	}),
	ehrIntegration: one(ehrIntegrations, {
		fields: [healthRecordUploads.ehrIntegrationId],
		references: [ehrIntegrations.id]
	}),
}));

export const consultationsRelations = relations(consultations, ({one}) => ({
	user: one(users, {
		fields: [consultations.userId],
		references: [users.id]
	}),
}));

export const roleResourcePermissionsRelations = relations(roleResourcePermissions, ({one}) => ({
	role_roleId: one(roles, {
		fields: [roleResourcePermissions.roleId],
		references: [roles.id],
		relationName: "roleResourcePermissions_roleId_roles_id"
	}),
	role_targetRoleId: one(roles, {
		fields: [roleResourcePermissions.targetRoleId],
		references: [roles.id],
		relationName: "roleResourcePermissions_targetRoleId_roles_id"
	}),
}));